// https://next-auth.js.org/configuration/pages#oauth-sign-in

import { signIn, useSession } from "next-auth/react"
import Link from "next/link"
import Image from "next/image"
import Logo from "../../components/ui/Logo"
import { useRouter } from 'next/router'
import fixtheopsLogo from '../../public/fixtheops-logo/fixtheops-name+logo-transparent.png'
import { getServerSession } from "next-auth"
import { GetServerSideProps } from "next"

import prisma from '@lib/prismadb'
import { authOptions } from '../api/auth/[...nextauth]'
import HeaderLanding from "@components/Landing/Header";

export default function SignIn() {
  const { status } = useSession();
  const router = useRouter();

  if (status === "authenticated") {
    router.push("/challenges");
  }

  return (
    <>
      <HeaderLanding />

      <section className="bg-gray-50">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0 -mt-[5.75rem] pt-[5.75rem]">
          {/* <Logo href="/" className="flex items-center mb-8 text-2xl font-semibold text-gray-900" /> */}
          {/* <Image
            src={fixtheopsLogo}
            alt="app logo"
            placeholder="blur"
            className="mb-16"
            width="200"
            height="200"
          /> */}

          <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl text-center">
                Login
              </h1>

              <div
                className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4"
                role="alert"
              >
                <p className="font-bold">
                  Dear visitor, this website is in maintenance{" "}
                </p>
                <p>
                  You should still be able to login but the dynamic kubernetes
                  environments are shut down. The reason is the lack of free
                  time to work on FixTheOps & the high cost of the project. To
                  stay updated, you can check on{" "}
                  <Link
                    className="underline"
                    href={`https://discord.com/invite/bBwVRrNAW8`}
                  >
                    Discord
                  </Link>
                  . <br />
                  Best, <i>François.</i>
                </p>
              </div>
              {/* <p className="font-light text-gray-700">
                Only Github login is supported
              </p> */}

              <Link
                href="#"
                className="w-full font-medium leading-5 px-5 py-3 border rounded-md inline-flex justify-center items-center hover:bg-gray-100 shadow"
                onClick={() => signIn("github", { callbackUrl: "/challenges" })}
              >
                {/* <svg className="w-5 h-5 mr-2" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_13183_10121)">
                        <path d="M20.3081 10.2303C20.3081 9.55056 20.253 8.86711 20.1354 8.19836H10.7031V12.0492H16.1046C15.8804 13.2911 15.1602 14.3898 14.1057 15.0879V17.5866H17.3282C19.2205 15.8449 20.3081 13.2728 20.3081 10.2303Z" fill="#3F83F8"></path>
                        <path d="M10.7019 20.0006C13.3989 20.0006 15.6734 19.1151 17.3306 17.5865L14.1081 15.0879C13.2115 15.6979 12.0541 16.0433 10.7056 16.0433C8.09669 16.0433 5.88468 14.2832 5.091 11.9169H1.76562V14.4927C3.46322 17.8695 6.92087 20.0006 10.7019 20.0006V20.0006Z" fill="#34A853"></path>
                        <path d="M5.08857 11.9169C4.66969 10.6749 4.66969 9.33008 5.08857 8.08811V5.51233H1.76688C0.348541 8.33798 0.348541 11.667 1.76688 14.4927L5.08857 11.9169V11.9169Z" fill="#FBBC04"></path><path d="M10.7019 3.95805C12.1276 3.936 13.5055 4.47247 14.538 5.45722L17.393 2.60218C15.5852 0.904587 13.1858 -0.0287217 10.7019 0.000673888C6.92087 0.000673888 3.46322 2.13185 1.76562 5.51234L5.08732 8.08813C5.87733 5.71811 8.09302 3.95805 10.7019 3.95805V3.95805Z" fill="#EA4335"></path>
                        </g><defs><clipPath id="clip0_13183_10121"><rect width="20" height="20" fill="white" transform="translate(0.5)"></rect></clipPath></defs>
                    </svg> */}
                <svg
                  className="w-5 h-5 mr-2"
                  height="32"
                  width="32"
                  aria-hidden="true"
                  viewBox="0 0 16 16"
                  version="1.1"
                  data-view-component="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"
                  ></path>
                </svg>
                Log in with Github
              </Link>
              <form className="space-y-4 md:space-y-6" action="#">
                {/* <div>
                          <label 
                            // for="email" 
                            className="block mb-2 text-sm font-medium text-gray-900">Your email</label>
                          <input disabled type="email" name="email" id="email" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@company.com" required />
                      </div>
                      <div>
                          <label 
                          //  for="password" 
                            className="block mb-2 text-sm font-medium text-gray-900">Password</label>
                          <input disabled type="password" name="password" id="password" placeholder="••••••••" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500" required/>
                      </div>
                      <div className="flex items-center justify-between">
                          <div className="flex items-start">
                              <div className="flex items-center h-5">
                                <input id="remember" aria-describedby="remember" type="checkbox" className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800" required/>
                              </div>
                              <div className="ml-3 text-sm">
                                <label 
                                  // for="remember"
                                  className="text-gray-500 dark:text-gray-300">Remember me</label>
                              </div>
                          </div>
                          <a href="#" className="text-sm font-medium text-primary-600 hover:underline">Forgot password?</a>
                      </div>
                      <button disabled type="submit" className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Sign in</button> */}
                {/* <p className="text-sm font-light text-gray-500">
                        Don’t have an account yet? <a href="#" className="font-medium text-primary-600 hover:underline">Sign up</a>
                    </p> */}
                <p className="text-sm font-light text-gray-500">
                  Don&apos;t want to Login?
                  <Link
                    href="/"
                    className="font-medium text-primary-600 hover:underline ml-2"
                  >
                    Come back to Landing page
                  </Link>
                </p>

                <p className="text-sm font-light text-gray-500">
                  No personal information is shared with 3rd parties.
                  <Link
                    href="https://github.com/FixTheOps/fixtheops-public/blob/main/docs/FAQ.md#how-are-you-using-my-email"
                    className="font-medium text-primary-600 hover:underline ml-2"
                    target={"_blank"}
                  >
                    Learn more how your data is used.
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const session = await getServerSession(context.req, context.res, authOptions);

  if (session) {
    return {
      redirect: {
        destination: "/challenges",
        permanent: false,
      },
    };
  }

  // const invitationCode = context.query?.code

  // if (!invitationCode) {
  //   return {
  //     redirect: {
  //       destination: '/',
  //       permanent: false,
  //     }
  //   }
  // }

  // const invitation = await prisma.waitingList.findFirst({
  //   where: {
  //     code: invitationCode as string
  //   }
  // })

  // if (!invitation) {
  //   return {
  //     redirect: {
  //       destination: '/',
  //       permanent: false,
  //     }
  //   }
  // }

  // console.log('invitation code to access the page:', invitationCode)

  return {
    props: {},
  };
}